﻿export default function () {
	const searchBars = document.querySelectorAll('input.search-bar');
	const searchSuggestionsWrapper = document.querySelector('.search-suggestions');
	const searchSuggestions = document.getElementById('searchSuggestions');
	if (searchBars && searchSuggestionsWrapper && searchSuggestions) {
		const searchInputWrapper = document.querySelector('.custom-search-input');
		const mobileSearchWrapper = document.querySelector('.search_mob_wp');
		searchBars.forEach(search => {
			search.addEventListener('keyup', (event) => {
				if (search.value.length >= 4) {
					const params = new URLSearchParams({
						query: search.value
					});

					$.get("/umbraco/surface/searchsurface/GetSearchSuggestions?" + params, function (data) {
						searchSuggestions.innerHTML = data;
						searchSuggestionsWrapper.classList.add('active');
						document.body.classList.add('search-suggestions-active');
					}, 'text');
				} else {
					searchSuggestionsWrapper.classList.remove('active');
					document.body.classList.remove('search-suggestions-active');
					searchSuggestions.innerHTML = '';
				}
			})
		});

		const outsideSearchClickListener = event => {
			if (document.body.classList.contains('search-suggestions-active') && !searchSuggestionsWrapper.contains(event.target)
				&& !searchInputWrapper.contains(event.target) && !mobileSearchWrapper.contains(event.target)) {
				document.body.classList.remove('search-suggestions-active');
				searchSuggestionsWrapper.classList.remove('active');
			}
		}

		document.addEventListener('click', outsideSearchClickListener);
	}
}